import React from 'react'
import '../Styles/footer.css'
import logo from './logoo.png'

const Footer = () => {
  return (
    <div>
      <section className='footer__below'>
       <div className='footer__sec'>
         <div className='row_footer'>
           <div className='col_footerb'>
             <h2><img src={logo}/></h2>
             <br />
             <p>Xceed Office, created by Mohammad Ali, delivers vibrant and sustainable workspaces for today’s creators and leaders. We blend style, comfort, and smart design to spark ideas and meaningful connections. Whether you’re launching a startup, freelancing your passion, or leading a growing team, every corner of Xceed Office is crafted to keep you inspired, productive, and excited to come to work each day.</p>
           </div>
           <div className='col_footer'>
            <h2>Company</h2>
            <br /><br />
            <a href="/about">About</a>
            <br /><br />
            <a href="/contact">Contact Us</a>
            <br /><br />
            <a href="/careers">Careers</a>
            <br /><br />
            <a href="/faq">Faq's</a>
           </div>
           <div className='col_footer'>
            <h2>Contact Us</h2>
            <br /><br />
            <i style={{color:"black",opacity:0.5}} class="ri-phone-fill"></i>

            <a href="tel:+(281) 717-6060" >&nbsp;&nbsp;(+346) 387 7187</a>
            <br /><br />
            <i style={{color:"black",opacity:0.5}} class="ri-mail-line"></i>
            <a href="mailto:info@33percentfund.com" >&nbsp;&nbsp;info@Xceed.com</a>
            <br /><br />
            <i style={{color:"black",opacity:0.5}} class="ri-map-pin-2-fill"></i>

            <a href='#'>&nbsp;&nbsp;2485 Katy Freeway, Suite 300 Katy TX 77494</a>
           </div>
           <div className='col_footer'>

           <i style={{color:"black"}} class="ri-facebook-fill"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
           <i style={{color:"black"}} class="ri-instagram-fill"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
           <i style={{color:"black"}} class="ri-twitter-fill"></i>
           </div>
         </div>
       </div>
      </section>
    </div>
  )
}

export default Footer